import { render, staticRenderFns } from "./LandingAppDescription.vue?vue&type=template&id=b7f8987c&scoped=true"
import script from "./LandingAppDescription.vue?vue&type=script&lang=js"
export * from "./LandingAppDescription.vue?vue&type=script&lang=js"
import style0 from "./LandingAppDescription.vue?vue&type=style&index=0&id=b7f8987c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f8987c",
  null
  
)

export default component.exports